import { API } from '@const'
import axios from 'axios'
import { store } from '@redux/store'
import { ACTION_TYPE as AUTH_ACTION_TYPE } from '@redux/reducers/auth'
import { ACTION_TYPE as DATA_SERVICE_ACTION_TYPE } from '@redux/reducers/data-service'
import { addToast } from './toast'
import { getCodeMsg } from './translation'

export function apiRequest(method, apiUrl, params, successCallback, errorCallback, hideToast, type, hideErrorToast) {
    if (!store.getState().auth) {
        addToast('Auth service not ready.', 'error')
        return
    }

    const server = process.env.REACT_APP_ENVIROMENT === "local" ? "" : API.ZIO_CENTER_SERVER

    const config = {
        method: method,
        url: server + apiUrl,
        headers: {
            Authorization: store.getState().auth.token,
        },
    }

    if (type) {
        config.headers['Content-Type'] = type
    }

    if (method === 'get') {
        config.params = params
    } else {
        config.data = params
    }

    axios(config)
        .then((res) => {
            if (res.data.code === 0) {
                if (!hideToast) {
                    addToast(getResponseMessage(res), 'success')
                }
                if (successCallback instanceof Function) {
                    if (res.data?.page) {
                        const data = {
                            data: res.data.data,
                            page: res.data.page
                        }
                        successCallback(data)
                    } else {
                        successCallback(res.data.data)
                    }
                    
                }
            } else {
                if (!hideErrorToast) {
                    addToast(getResponseMessage(res), 'error')
                }
                
                if (res.data.code === 16001 || res.data.code === 16002) {
                    // TODO: need group up the actions below
                    store.dispatch({ type: AUTH_ACTION_TYPE.LOGOUT })
                    store.dispatch({ type: DATA_SERVICE_ACTION_TYPE.CLEAR })
                    return
                }

                if (errorCallback instanceof Function) {
                    errorCallback(res.data)
                }
            }
        })
        .catch((err) => {
            if (err.response) {
                addToast(getResponseMessage(err.response), 'error')
            }
            if (errorCallback instanceof Function) {
                errorCallback(err)
            }
        })

    function getResponseMessage(res) {
        const code = res.data.code === undefined ? '500' : res.data.code
        const msg = res.data.msg
        let errMsg = ''
       
        errMsg = res.data.dynamic_parameter
                    ? getCodeMsg(code, res.data.data)
                    : getCodeMsg(code)

        if (errMsg.toString() === code.toString() || (msg && getCodeMsg(code, { lng: 'en' }) !== msg)) {
            return msg
        }

        if (String(code) === '302802') {
            // Special case for 302802, it should return the message with dynamic parameters
            const { pf_sub_pf_id } = res.data.data || {}
            return getCodeMsg(code, { pf_sub_pf_id })
        }

        if (String(code) === '302808') {
            // Special case for 302808, it should return the message with dynamic parameters
            const { game_code, pf_sub_pf_id } = res.data.data || {}
            return getCodeMsg(code, { game_code, pf_sub_pf_id })
        }

        return errMsg
    }
}
